import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { useTable } from './Hooks';
import { Animate } from './Animate';
const LoaderProps = {
	children: PropTypes.element,
};

export const Loader = ({ children }) => {
	const { state } = useTable();
	const exit = { opacity: 0, transition: 'opacity 300ms ease-out' };
	const enter = { opacity: 1, transition: 'opacity 300ms ease-in' };
	return (
		<Animate show={state.loading} animation={{ enter, exit }}>
			{children ? (
				cloneElement(children, { style: { ...children.props.style, ...exit } })
			) : (
				<div className='reatable-loader' style={exit}>
					<div className='rt-loader' />
				</div>
			)}
		</Animate>
	);
};

Loader.propTypes = LoaderProps;
